export default "__VITE_ASSET__812b3bb0__"